import RuntimeUtils from 'src/common/js/runtimeUtils';
import { $delete, $get, $post } from 'src/utils/httpUtil';
import { base64UrlEncode } from 'src/utils/commonUtils';

const PUBLIC_URL = `${RuntimeUtils.instance.getObvServiceProtocol()}//${RuntimeUtils.instance.getConsoleServiceHostname()}`;
const BASE_URL = `/bimserver/console/v3/share`;
/**
 * 分享0，视图；1，模型；2，组装；3，对比
 *
 */
export const shareFile = (data) => {
    return new Promise((resolve, reject) => {
        const url = PUBLIC_URL + BASE_URL;
        $post(url, data)
            .then((res) => {
                resolve(res);
            })
            .catch((err) => {
                reject(err)
            });
    });
};

/**
 * 查询分享列表
 *
 */
export const getShareList = (data) => {
    return new Promise((resolve, reject) => {
        const url = PUBLIC_URL + BASE_URL;
        $get(url, data)
            .then((res) => {
                resolve(res);
            })
            .catch(reject);
    });
};

/**
 * 取消分享
 *
 */
export const cancelShare = (data) => {
    return new Promise((resolve, reject) => {
        const url = PUBLIC_URL + BASE_URL;
        $delete(url, data)
            .then((res) => {
                resolve(res);
            })
            .catch(reject);
    });
};

/**
 * 获取分享信息
 *
 */
export const getShareMess = (data) => {
    return new Promise((resolve, reject) => {
        const url = `${PUBLIC_URL}${BASE_URL}/info`;
        $get(url, data)
            .then((res) => {
                resolve(res);
            })
            .catch((err) => {
                reject(err)
            });
    });
};



// WEBPACK FOOTER //
// ./src/utils/shareUtils.js